import React from 'react';
import networkIcon from '@assets/address/error.png';
import addressIcon from '@assets/address/empty2.png';
import './index.css';

interface CustomKtdErrorViewProps {
  title?: string;
  subTitle?: string;
  dtCode?: string;
  type?: string;
  spec?: string;
  buttonTitle?: string;
  onClickButton?: () => void;
}

const CustomKtdErrorView: React.FC<CustomKtdErrorViewProps> = ({
  title = '',
  subTitle = '',
  dtCode = '',
  type = 'network',
  spec = 'normal',
  buttonTitle = '',
  onClickButton,
}) => {
  const normalizedType = type === 'address' ? 'address' : 'network';
  const normalizedSpec = spec === 'small' ? 'small' : 'normal';
  const icon = normalizedType === 'address' ? addressIcon : networkIcon;

  return (
    <div
      className={[
        'custom-ktd-error-view',
        `custom-ktd-error-view--${normalizedType}`,
        `custom-ktd-error-view--${normalizedSpec}`,
      ].join(' ')}
      data-type={normalizedType}
      data-spec={normalizedSpec}
      role="status"
      aria-live="polite"
    >
      <img
        className="custom-ktd-error-view-icon"
        src={icon}
        alt=""
        aria-hidden="true"
      />
      <div className="custom-ktd-error-view-title">{title}</div>
      {subTitle ? <div className="custom-ktd-error-view-subtitle">{subTitle}</div> : null}
      {dtCode ? <div className="custom-ktd-error-view-code">{dtCode}</div> : null}
      {buttonTitle ? (
        <button
          className="custom-ktd-error-view-button"
          type="button"
          onClick={onClickButton}
        >
          {buttonTitle}
        </button>
      ) : null}
    </div>
  );
};

export default CustomKtdErrorView;
